
export default function NoPage() {
    return(
        <h1>NO PAGE!</h1>
    )
}